// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for the entire container */
.container {
    text-align: center;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  /* Styles for the main heading */
  .main-heading {
    font-size: 2.5em;
    margin-bottom: 20px;
    color: #333;
  }
  
  /* Styles for the authenticated content */
  .auth-content {
    margin: 20px 0;
  }
  
  /* Styles for the welcome message */
  .welcome-message {
    font-size: 2em;
    margin-bottom: 20px;
    color: #555;
  }
  
  /* Styles for the click count */
  .click-count {
    font-size: 1.5em;
    margin-top: 20px;
    color: #777;
  }
  
  /* Styles for the button */
  .click-button {
    padding: 10px 20px;
    font-size: 1em;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .click-button:hover {
    background-color: #0056b3;
  }
  
  /* Styles for the login prompt */
  .login-prompt {
    font-size: 2em;
    margin-bottom: 20px;
    color: #555;
  }
  
  /* Styles for the link */
  .login-link {
    color: #007bff;
    text-decoration: none;
    font-weight: bold;
  }
  
  .login-link:hover {
    text-decoration: underline;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;EAChC;;EAEA,gCAAgC;EAChC;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA,yCAAyC;EACzC;IACE,cAAc;EAChB;;EAEA,mCAAmC;EACnC;IACE,cAAc;IACd,mBAAmB;IACnB,WAAW;EACb;;EAEA,+BAA+B;EAC/B;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,gCAAgC;EAChC;IACE,cAAc;IACd,mBAAmB;IACnB,WAAW;EACb;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B","sourcesContent":["/* Styles for the entire container */\n.container {\n    text-align: center;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n  }\n  \n  /* Styles for the main heading */\n  .main-heading {\n    font-size: 2.5em;\n    margin-bottom: 20px;\n    color: #333;\n  }\n  \n  /* Styles for the authenticated content */\n  .auth-content {\n    margin: 20px 0;\n  }\n  \n  /* Styles for the welcome message */\n  .welcome-message {\n    font-size: 2em;\n    margin-bottom: 20px;\n    color: #555;\n  }\n  \n  /* Styles for the click count */\n  .click-count {\n    font-size: 1.5em;\n    margin-top: 20px;\n    color: #777;\n  }\n  \n  /* Styles for the button */\n  .click-button {\n    padding: 10px 20px;\n    font-size: 1em;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .click-button:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Styles for the login prompt */\n  .login-prompt {\n    font-size: 2em;\n    margin-bottom: 20px;\n    color: #555;\n  }\n  \n  /* Styles for the link */\n  .login-link {\n    color: #007bff;\n    text-decoration: none;\n    font-weight: bold;\n  }\n  \n  .login-link:hover {\n    text-decoration: underline;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
